import { Injectable } from '@angular/core';

const HOLDER_STYLE: Partial<CSSStyleDeclaration> = {
  position: 'fixed',
  left: '8px',
  bottom: '8px',
  width: '40px',
  height: '40px',
  opacity: '0',
  border: '0',
  padding: '0',
  fontSize: '16px',
  zIndex: '100000',
  caretColor: 'transparent',
};

@Injectable({ providedIn: 'root' })
export class IosKeyboardHoldService {
  private holder?: HTMLInputElement;

  hold(): void {
    if (!isIosDevice()) {
      return;
    }
    if (this.holder) {
      this.holder.focus();
      return;
    }

    const input = document.createElement('input');
    input.type = 'tel';
    input.inputMode = 'numeric';
    input.autocomplete = 'one-time-code';
    Object.assign(input.style, HOLDER_STYLE);
    input.addEventListener('blur', this.keepFocus);
    document.body.appendChild(input);
    input.focus();
    this.holder = input;
  }

  transferTo(target?: HTMLInputElement): void {
    if (!target) {
      return;
    }
    this.clearBlurTrap();
    target.focus();
    target.click();
    this.release();
  }

  release(): void {
    this.clearBlurTrap();
    this.holder?.remove();
    this.holder = undefined;
  }

  private readonly keepFocus = (): void => {
    queueMicrotask(() => this.holder?.focus());
  };

  private clearBlurTrap(): void {
    this.holder?.removeEventListener('blur', this.keepFocus);
  }
}

function isIosDevice(): boolean {
  const ua = navigator.userAgent;
  if (/iPad|iPhone|iPod/.test(ua)) {
    return true;
  }
  return navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1;
}
